import React from "react";
import { Form } from "@sscs/ui";
import styles from "./dialog.module.scss";

type DialogDangerZoneProps = {
  dangerZone?: string;
};

const DialogDangerZone = ({
  dangerZone,
}: DialogDangerZoneProps): React.JSX.Element | null => {
  return dangerZone ? (
    <Form.TextField
      label={
        <span className={styles["danger-zone-label"]}>
          This action cannot be undone.
          <br /> Please type{" "}
          <strong className={styles["danger-zone-confirm"]}>
            {dangerZone}
          </strong>{" "}
          to confirm.
        </span>
      }
      name="dangerZone"
    />
  ) : null;
};

export default DialogDangerZone;
